import React from "react";

import TableTransfer from "../../FormItem/TableTransfer";

const leftTableColumns = [
  {
    dataIndex: "primary_hmg_name",
    title: "HMG Name",
  },
  {
    dataIndex: "primary_hmg_project_name",
    title: "Project Name",
    render: (text, record) => (
      <span>
        {`${
          record.secondary_hmg_project_name
            ? `${record.primary_hmg_name} - `
            : ""
        }${text}`}
        {record.secondary_hmg_project_name
          ? ` ,  ${record.secondary_hmg_name} - ${record.secondary_hmg_project_name}`
          : null}
        {record.third_hmg_project_name
          ? ` ,  ${record.third_hmg_name} - ${record.third_hmg_project_name}`
          : null}
        {record.fourth_hmg_project_name
          ? ` ,  ${record.fourth_hmg_name} - ${record.fourth_hmg_project_name}`
          : null}
      </span>
    ),
  },
  {
    dataIndex: "hotel_name",
    title: "Hotel Name",
  },
  {
    dataIndex: "hotel_code",
    title: "Hotel Code",
  },
];
const rightTableColumns = [
  {
    dataIndex: "primary_hmg_name",
    title: "HMG Name",
  },
  {
    dataIndex: "primary_hmg_project_name",
    title: "Project Name",
    render: (text, record) => (
      <span>
        {`${
          record.secondary_hmg_project_name
            ? `${record.primary_hmg_name} - `
            : ""
        }${text}`}
        {record.secondary_hmg_project_name
          ? ` ,  ${record.secondary_hmg_name} - ${record.secondary_hmg_project_name}`
          : null}
        {record.third_hmg_project_name
          ? ` ,  ${record.third_hmg_name} - ${record.third_hmg_project_name}`
          : null}
        {record.fourth_hmg_project_name
          ? ` ,  ${record.fourth_hmg_name} - ${record.fourth_hmg_project_name}`
          : null}
      </span>
    ),
  },

  {
    dataIndex: "hotel_name",
    title: "Hotel Name",
  },
  {
    dataIndex: "hotel_code",
    title: "Hotel Code",
  },
];

class HotelMapping extends React.Component {
  state = {
    targetKeys: [],
  };

  componentDidUpdate(prevProps, _) {
    const isAllHotelsForCorporateChanged =
      prevProps.allHotelsForCorporate !== this.props.allHotelsForCorporate
        ? true
        : false;

    const isFinishChanged =
      prevProps.finish !== this.props.finish ? true : false;

    const isInitialValueChanged =
      prevProps.initialValue !== this.props.initialValue ? true : false;

    const hasInitialValueHotelId = this.props.initialValue.hotels_ids
      ? true
      : false;

    const isSingleHotelCreation =
      this.props.createStatus === true && this.props.hotelGetData.length === 1
        ? true
        : false;

    let isCorporateUserCreation = false;

    const hasMainRoleChanged =
      prevProps.mainRoleId !== this.props.mainRoleId ? true : false;

    const hasHmgChanged =
      prevProps.corporateUserHmgId !== this.props.corporateUserHmgId
        ? true
        : false;

    if (hasHmgChanged || hasMainRoleChanged) {
      isCorporateUserCreation = this.isCorporateUserCreationHandler();
    }

    if (isAllHotelsForCorporateChanged) {
      const allHotelsForCorporate = this.props.allHotelsForCorporate;
      this.setState({ targetKeys: allHotelsForCorporate });
      this.props.assignHotelsHandler(allHotelsForCorporate);
    }

    if ((isInitialValueChanged || isFinishChanged) && hasInitialValueHotelId) {
      const hotelIds = this.props.initialValue.hotels_ids;
      this.setState({ targetKeys: hotelIds });
      this.props.assignHotelsHandler(hotelIds);
    }

    if (!hasInitialValueHotelId && isCorporateUserCreation) {
      const hmgHotelIds = this.hmgHotelIdsHandler();
      this.setState({ targetKeys: hmgHotelIds });
      this.props.assignHotelsHandler(hmgHotelIds);
    }

    if (
      !hasInitialValueHotelId &&
      !isCorporateUserCreation &&
      !isSingleHotelCreation &&
      hasMainRoleChanged
    ) {
      this.setState({ targetKeys: [] });
      this.props.assignHotelsHandler([]);
    }

    if (
      (isInitialValueChanged || isFinishChanged) &&
      !hasInitialValueHotelId &&
      isSingleHotelCreation
    ) {
      const singleHotelId = [this.props.hotelGetData[0]._id];
      this.setState({ targetKeys: singleHotelId });
      this.props.assignHotelsHandler(singleHotelId);
    }
  }

  hmgHotelIdsHandler = () => {
    const corporateUserHmgId = this.props.corporateUserHmgId;

    const hmgHotels = this.props.hotelGetData?.filter(
      (ele) => ele?.hmg_id === corporateUserHmgId,
    );

    const hmgHotelIds = hmgHotels?.map((ele) => ele._id);

    return hmgHotelIds;
  };

  isCorporateUserCreationHandler = () => {
    const mainRoleId = this.props.mainRoleId;
    const corporateUserHmgId = this.props.corporateUserHmgId;

    const mainRole = this.props.mainRolesGetData?.find(
      (ele) => ele?._id === mainRoleId,
    );

    const corporateUserHmg = this.props.hmgMainGetData?.find(
      (ele) => ele?._id === corporateUserHmgId,
    );

    const isCorporateUserCreation =
      mainRole?.main_role_name?.toLowerCase() === "corporate" &&
      corporateUserHmg
        ? true
        : false;

    return isCorporateUserCreation;
  };

  onChange = async (nextTargetKeys, direction, moveKeys) => {
    let check = true;
    if (
      direction === "left" &&
      !(await this.props.checkUserUsesHotel(moveKeys))
    )
      check = false;

    if (check) {
      this.setState({ targetKeys: nextTargetKeys });
      this.props.assignHotelsHandler(nextTargetKeys);
    }
  };

  triggerShowSearch = (showSearch) => {
    this.setState({ showSearch });
  };

  render() {
    return (
      <div>
        <TableTransfer
          formName="hotels"
          dataSource={this.props.hotelGetData}
          targetKeys={this.state.targetKeys}
          lazy={false}
          disabled={false}
          showSearch={true}
          rowKey={(record) => record._id}
          locale={{
            itemUnit: "hotel",
            itemsUnit: "hotels",
            notFoundContent: "No hotels",
            searchPlaceholder: "Search here",
          }}
          onChange={this.onChange}
          filterOption={(inputValue, item) =>
            item.primary_hmg_name
              ?.toUpperCase()
              .indexOf(inputValue?.toUpperCase()) !== -1 ||
            item.hotel_name
              ?.toUpperCase()
              .indexOf(inputValue?.toUpperCase()) !== -1 ||
            item.hotel_code
              ?.toUpperCase()
              .indexOf(inputValue?.toUpperCase()) !== -1 ||
            item.primary_hmg_project_name
              ?.toUpperCase()
              .indexOf(inputValue?.toUpperCase()) !== -1 ||
            (item.secondary_hmg_project_name
              ? item.secondary_hmg_project_name
                  ?.toUpperCase()
                  .indexOf(inputValue?.toUpperCase()) !== -1
              : false) ||
            (item.third_hmg_name
              ? item.third_hmg_name
                  ?.toUpperCase()
                  .indexOf(inputValue?.toUpperCase()) !== -1
              : false) ||
            (item.fourth_hmg_name
              ? item.fourth_hmg_name
                  ?.toUpperCase()
                  .indexOf(inputValue?.toUpperCase()) !== -1
              : false)
          }
          leftColumns={leftTableColumns}
          rightColumns={rightTableColumns}
          form={this.props.form}
          listStyle={{
            width: "100%",
          }}
        />
      </div>
    );
  }
}

export default HotelMapping;
